/**
 * @generated SignedSource<<95be133b915c1afc3f29514e75a5c50d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type WidgetOverviewSettings_Store$data = {
  readonly publicTeams: ReadonlyArray<{
    readonly id: string;
    readonly " $fragmentSpreads": FragmentRefs<"TeamSelectList_Team">;
  }>;
  readonly " $fragmentType": "WidgetOverviewSettings_Store";
};
export type WidgetOverviewSettings_Store$key = {
  readonly " $data"?: WidgetOverviewSettings_Store$data;
  readonly " $fragmentSpreads": FragmentRefs<"WidgetOverviewSettings_Store">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "WidgetOverviewSettings_Store",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Team",
      "kind": "LinkedField",
      "name": "publicTeams",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "TeamSelectList_Team"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Store",
  "abstractKey": null
};

(node as any).hash = "bd514d5c751afc23100f45dd10d969cf";

export default node;
